import {
  MakeOptions,
  CartItemTemplate,
  GetTemplateCartItems,
  UpdateCartItems,
} from "./types";

/**
 * カート商品テンプレート
 * @param item テンプレートに渡すデータ
 * @param options option要素
 * @param quantitySlectSelector 数量変更セレクトボックス要素
 * @param deleteBtnSelector 商品削除ボタン要素
 */
export const cartItemTemplate: CartItemTemplate = (
  item,
  options,
  quantitySlectSelector,
  deleteBtnSelector
) => `
<div class="cart-body-item cart-additional__item" data-itemcode="${
  item.itemCode
}">
  <div class="cart-expand-small">
    <a href="${item.url}" class="cart-body-item__name dialog-opener">
      ${item.name}
    </a>
  </div>
  <div
    class="cart-expand-small js-cart-item-point"
    ${item.point ? "" : "hidden"}
  >
    <p class="cart-additional__point s-point">${item.point}ポイント</p>
  </div>
  <div class="mt-2 cart-body-item__detail">
    <div class="cart-body-item__img">
      <img src="${item.thumbnailImagePath}" alt="${
  item.name
}" width="86" height="65" />
      <p class="s-cold-storage--${item.wappenId}">${item.wappen}</p>
    </div>
    <div class="cart-expand-large cart-additional__expanded-name">
      <a href="${item.url}" class="cart-body-item__name dialog-opener">
        ${item.name}
      </a>
      <div
        class="js-cart-item-point"
        ${item.point ? "" : "hidden"}
      >
        <p class="cart-additional__point s-point">${item.point}ポイント</p>
      </div>
    </div>
    <div class="cart-body-item__change">
      <div class="cart-body-item__calculate">
        <p>${item.price}円</p>
        <select name="quantity"
          class="cart-quantity cart-body-item__quantity ${quantitySlectSelector}"
          ${item.isChangetable ? "" : "disabled"}
        >
          ${options}
        </select>
        個
      </div>
      <div class="cart-body-item__buttons">
        <button
          class="cart-btn cart-body-item__delete s-button--gray ${deleteBtnSelector}"
          ${!item.isDeletable || !item.isChangetable ? "hidden" : ""}
        >
          <span class="icon-close icon-close--gray"></span>
          <span>削除</span>
        </button>
      </div>
    </div>
  </div>
</div>
`;

/**
 * 注文確認画面用カート商品テンプレート
 * @param item テンプレートに渡すデータ
 * @param options option要素
 * @param quantitySlectSelector 数量変更セレクトボックス要素
 * @param deleteBtnSelector 商品削除ボタン要素
 */
export const cartItemAtDetailTemplate: CartItemTemplate = (
  item,
  options,
  quantitySlectSelector,
  deleteBtnSelector
) => `
<div class="order-confirm__order-item" data-itemcode="${item.itemCode}">
  <div class="order-confirm__img">
    <img src="${item.thumbnailImagePath}" alt="${item.name}" />
  </div>
  <div class="order-confirm__detail">
    <h3 class="order-confirm__item-name">
      ${item.name}
    </h3>
    <div class="flex flex-wrap items-center">
      <div class="order-confirm__calculate">
        <div class="order-confirm__cold-storage">
          <p class="s-cold-storage--${item.wappenId}">${item.wappen}</p>
        </div>
        <p class="order-confirm__item-price">
          <span>${item.price} 円</span><span>×</span>
        </p>
        <select
          name="quantity"
          class="order-confirm__quantity ${quantitySlectSelector}"
          ${item.isChangetable ? "" : "disabled"}
        >
          ${options}
        </select>
        <p class="order-confirm__subtotal" hidden>小計: ${item.price}円</p>
      </div>
      <button
        class="s-button--gray order-confirm__delete ${deleteBtnSelector}"
        type="button"
        ${!item.isDeletable || !item.isChangetable ? "hidden" : ""}
      >
        <span class="icon-close--gray"></span> 削除
      </button>
    </div>
  </div>
</div>
`;

/**
 * 1~xまでのoption要素を返す
 * @param end 終了数
 * @param selected 選択値
 */
export const makeOptions: MakeOptions = (end, selected) =>
  [...Array(end)]
    .map(
      (_, i) =>
        `<option value="${i + 1}"${i + 1 === selected ? " selected" : ""}>${
          i + 1
        }</option>`
    )
    .join("");

/**
 * カート商品テンプレートにデータをセットして返す
 * @param cartItemTemplate テンプレートを返す関数
 * @param formattedPrice 3桁区切りでカンマを付与した価格を返す関数
 * @param makeOptions option要素の生成関数
 * @param quantitySlectSelector 数量変更セレクトボックス要素
 * @param deleteBtnSelector 商品削除ボタン要素
 */
export const getTemplateCartItems: GetTemplateCartItems = (
  cartItemTemplate,
  formattedPrice,
  makeOptions,
  quantitySlectSelector,
  deleteBtnSelector
) => (item) =>
  cartItemTemplate(
    { ...item, price: formattedPrice(item.price) },
    makeOptions(99, item.quantity),
    quantitySlectSelector,
    deleteBtnSelector
  );

/**
 * 注文確認画面用カート商品テンプレートにデータをセットして返す
 * @param cartItemAtDetailTemplate 注文確認画面用テンプレートを返す関数
 * @param formattedPrice 3桁区切りでカンマを付与した価格を返す関数
 * @param makeOptions option要素の生成関数
 * @param quantitySlectSelector 数量変更セレクトボックス要素
 * @param deleteBtnSelector 商品削除ボタン要素
 */
export const getTemplateCartItemsAtDetail: GetTemplateCartItems = (
  cartItemAtDetailTemplate,
  formattedPrice,
  makeOptions,
  quantitySlectSelector,
  deleteBtnSelector
) => (item) =>
  cartItemAtDetailTemplate(
    { ...item, price: formattedPrice(item.price) },
    makeOptions(99, item.quantity),
    quantitySlectSelector,
    deleteBtnSelector
  );

/**
 * カート商品要素更新
 * @param formattedPrice 3桁区切りでカンマを付与した価格を返す関数
 * @param itemDataAttribute アイテムコードdata属性
 * @param itemNameSelector 商品名セレクタ
 * @param pointSelector ポイントセレクタ
 * @param pointTextSelector ポイントテキストセレクタ
 * @param itemImageSelector 商品画像セレクタ
 * @param wappenSelector ワッペンセレクタ
 * @param wappenClassPrefix ワッペンクラスプレフィックス
 * @param itemPriceSelector 商品価格セレクタ
 * @param quantitySlectSelector 数量変更セレクトボックスセレクタ
 * @param deleteBtnSelector 商品削除ボタンセレクタ
 */
export const updateCartItems: UpdateCartItems = (
  formattedPrice,
  itemDataAttribute,
  itemNameSelector,
  pointSelector,
  pointTextSelector,
  itemImageSelector,
  wappenSelector,
  wappenClassPrefix,
  itemPriceSelector,
  quantitySlectSelector,
  deleteBtnSelector
) => ($root, item) => {
  $root.attr(itemDataAttribute, item.itemCode);
  $root.find(itemNameSelector).attr("href", item.url).text(item.name);
  item.point
    ? $root.find(pointSelector).removeAttr("hidden")
    : $root.find(pointSelector).attr("hidden", "hidden");
  $root.find(pointTextSelector).text(`${item.point}ポイント`);
  $root
    .find(itemImageSelector)
    .attr("src", item.thumbnailImagePath)
    .attr("alt", item.name);
  $root
    .find(wappenSelector)
    .removeClass()
    .addClass(`${wappenClassPrefix}${item.wappenId}`)
    .text(item.wappen);
  $root.find(itemPriceSelector).text(`${formattedPrice(item.price)}円`);
  $root
    .find(quantitySlectSelector)
    .val(item.quantity)
    .trigger("update")
    .prop("disabled", !item.isChangetable);
  !item.isDeletable || !item.isChangetable
    ? $root.find(deleteBtnSelector).attr("hidden", "hidden")
    : $root.find(deleteBtnSelector).removeAttr("hidden");
};
